import React from "react";
import styled from "styled-components";

const Style = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    position: relative;
    padding: 2rem 0 4rem;
    margin: 0 auto;
    width: 70%;
    .image {
        z-index: 5;
        margin-bottom: 0.7rem;
    }
    .text {
        z-index: 5;
        font-size: 1.1rem;
        text-align: center;
    }
    @media (max-width: 850px){
        width: calc(100% - 4rem);
        .title {
            z-index: 5;
            font-size: 1.6rem;
            font-weight: 800;
            margin-bottom: 0.7rem;
            letter-spacing: 2px;
        }
        .text {
            z-index: 5;
            font-size: 1.1rem;
            text-align: justify;
        }
    }
`;

export default function CenterImage({data}) {
    return (
      <Style>
        <div className="image">
            <img src={data.data.image} alt={data.title}/>
        </div>
        <div className="text">
            {data.data.text}
        </div>
      </Style>
  );
}
